import { ButtonVariant } from '../abstract-button/helpers'

export const TextButtonVariant = ButtonVariant

export const TextButtonIconPosition = {
  Start: 'start',
  End: 'end',
} as const

export const TextButtonSize = {
  Small: 'sm',
  Medium: 'md',
  Large: 'lg',
} as const
